import { render } from "./Report.vue?vue&type=template&id=a221d61e&scoped=true"
import script from "./Report.vue?vue&type=script&lang=js"
export * from "./Report.vue?vue&type=script&lang=js"

import "./Report.vue?vue&type=style&index=0&id=a221d61e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-a221d61e"

export default script